import { Box, Typography, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function ThirdPartyLibraries() {
  const navigate = useNavigate();

  return (
    <>
      <Box
        sx={{
          m: 1,
          border: 1,
          borderColor: "blue",
          p: 1,
          pb: 8,
        }}
      >
        <Typography variant="body">
          <strong>Third Party software</strong>
          <br />
          <br />
          Use and declarations related to Third party software Libraries and
          Software: <br />
          <br />
          To enable a seamless browsing experience to our customers, we rely on
          using the third party libraries and software. These third party
          libraries and software are governed by their own usage policies,
          declarations and privacy policies. Your use of ReUrja.com website
          automatically mandates you to follow the terms and conditions,
          governing rules / regulations, declarations, privacy policies etc.
          applicable under these Third party libraries and software. You may
          find the details of these at the below listed links. <br />
          <br />
          Third party software libraries and/or components Terms, Privacy
          policies, license references: <br />
          <br />
          • https://mui.com/ , https://mui.com/legal/
          <br />
          • https://github.com/remix-run/react-router,
          https://github.com/remix-run/react-router?tab=MIT-1-ov-file#readme
          <br />
          • https://github.com/dozoisch/react-google-recaptcha?tab=MIT-1-ov-file#readme
          <br />
          • https://www.svgrepo.com/page/licensing/
          <br />
          • React - https://github.com/facebook/react/blob/main/LICENSE
          <br />
          • Xlsx -
          https://github.com/SheetJS/sheetjs?tab=Apache-2.0-1-ov-file#readme
          <br />
          • React router dom -
          https://github.com/remix-run/react-router?tab=MIT-1-ov-file#readme
          <br />
          • Uuid -
          https://github.com/uuidjs/uuid?tab=MIT-1-ov-file#readme
          <br />
          • Nanoid -
          https://github.com/ai/nanoid?tab=MIT-1-ov-file#readme
          <br />
        </Typography>

        {/* Navigation Links */}
        <Box sx={{ mt: 3, pt: 2, borderTop: "1px solid #ddd" }}>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Navigate between pages:
          </Typography>
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            <Link
              onClick={() => navigate("/privacy-policy")}
              sx={{
                cursor: "pointer",
                color: "primary.main",
                textDecoration: "none",
                "&:hover": { textDecoration: "underline" },
              }}
            >
              ← Back to Privacy Policy
            </Link>
            <Link
              onClick={() => navigate("/tnc")}
              sx={{
                cursor: "pointer",
                color: "primary.main",
                textDecoration: "none",
                "&:hover": { textDecoration: "underline" },
              }}
            >
              Back to Terms & Conditions →
            </Link>
          </Box>
        </Box>
      </Box>
    </>
  );
}
